import script from "./tab-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-menu.vue?vue&type=script&setup=true&lang=ts"

import "./tab-menu.vue?vue&type=style&index=0&id=7e2668cc&lang=scss"

const __exports__ = script;

export default __exports__